export namespace TaskboardTelemetryConstants {
    export const GROUP_BY_CHANGED = "SprintsHub_Taskboard_GroupByChanged";
    export const ADD_NEW_PARENT_ITEM = "SprintsHub_Taskboard_AddNewParentItem";
    export const ZERO_DATA_ADD_NEW_ITEM = "SprintsHub_Taskboard_ZeroDataAddNewItem";
    export const PEOPLE_SWITCHER_CHANGED = "SprintsHub_Taskboard_PeopleSwitcherChanged";
    export const PEOPLE_SWITCHER_LOADED = "SprintsHub_Taskboard_PeopleSwitcherLoaded";
}
